import { SelectBox } from 'devextreme-react'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { FormGroup, Label } from 'reactstrap'
import { getPeron } from '../api'

const PeronSecimi = ({
    warehouseId,
    peronRef,
    selectedVehicles,
    selectedRow,
    groupedData
}) => {
    const [peronList, setPeronList] = useState([])

    useEffect(() => {
        const getPeronList = async () => {
            const response = await getPeron(warehouseId)
            setPeronList(response)
        }
        if (warehouseId) getPeronList()
    }, [warehouseId])

    const handleValueChanged = (e) => {
        const selectedPeronId = e.value;
        if (selectedPeronId) {
            const selectedPeron = peronList.find(p => p.address_id === selectedPeronId);
            if (selectedPeron) {
                const availableCapacity = selectedPeron.capacity - (selectedPeron.used_capacity || 0) - (selectedPeron.reserved_capacity || 0);
                const vehicleCount = selectedRow !== null && groupedData[selectedRow] ? groupedData[selectedRow].count : selectedVehicles[0].vehicles.length;
                if (vehicleCount > availableCapacity) {
                    toast.error("Peron kapasitesi yetersiz.");
                    if (peronRef.current) {
                        peronRef.current.instance.reset();
                    }
                    return;
                }
            }
        }
    };

    return (
        <div>
            <FormGroup>
                <Label >Peron</Label>
                <SelectBox
                    ref={peronRef}
                    id='peron-select'
                    dataSource={peronList}
                    searchEnabled={true}
                    displayExpr={(e) => {
                        if (e) {
                            return `${e.address_code} | (${e.used_capacity + e.reserved_capacity} / ${e.capacity})`
                        }
                    }}
                    valueExpr="address_id"
                    placeholder="Peron Seçiniz"
                    onValueChanged={handleValueChanged}
                />
            </FormGroup>
        </div>
    )
}

export default PeronSecimi